import intance from "../utils/axios";
import { ApiPaths } from "../helpers/api";
import { ChamCongNhanVien, LoaiChamCong, TongHopChamCong } from "@app/models/chamcong/ChamCong";
import { ImportFileChamCongRequest, LayMauFileChamCongRequest } from "@app/models/chamcong/FileChamCongRequest";
import { responseStatus } from "../constants";
import { CongNgoaiGioNhanVien } from "../models/chamcong/ChamNgoaiGio";

export const chamCongNhat = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.chamCongNhat, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const getLoaiChamCong = async () => {
    var rs: Array<LoaiChamCong> = [];
    await intance.get(ApiPaths.chamCong.getLoaiCong).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const getChamCongNhat = async (date: any) => {
    var rs: any;
    await intance.get(ApiPaths.chamCong.getChamCongNhat + "?ngay=" + date).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const getDayInMonth = async (nam: number, thang: number) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.getDayInMonth + "?thang=" + thang + "&nam=" + nam).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const layThongKeChamCong = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.layThongKe, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}
export const layTaiLieuChamCong = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.layTaiLieuChamCong, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}
export const layTongHopChamCong = async (thangNam: string) => {
    var rs: TongHopChamCong | null = new TongHopChamCong();
    await intance.get(ApiPaths.chamCong.layTongHopChamCongThang + "?thangNam=" + thangNam)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const trinhTongHopChamCong = async (thangNam: string, trinhPhoCVP: boolean) => {
    var data: TongHopChamCong = new TongHopChamCong();

    await intance.post(ApiPaths.chamCong.trinhTongHopChamCongThang + "?thangNam=" + thangNam + "&trinhPhoCVP=" + trinhPhoCVP)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return data;
}

export const pheDuyetTongHopChamCong = async (request: any) => {
    var data: TongHopChamCong = new TongHopChamCong();

    await intance.post(ApiPaths.chamCong.pheDuyetTongHopChamCongThang, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return data;
}
export const thuHoiTongHopChamCong = async (idCCTongHop: number) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.thuHoiTongHopChamCong + "?idCCTongHop=" + idCCTongHop)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const xuatBaoCaoChamCong = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.xuatBaoCao, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const xuatBaoCaoChamCongTongHop = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.xuatBaoCaoTongHop, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const layDanhSachChamCong = async () => {
    var rs: any;
    await intance.get(ApiPaths.chamCong.layDanhSachChamCong).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const layDanhSachChoDuyet = async () => {
    var rs: any;
    await intance.get(ApiPaths.chamCong.layDanhSachChoDuyet).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const layNgayCongNhanVien = async (id:number) => {
    var rs: any;
    await intance.get(ApiPaths.chamCong.layNgayCongNhanVien + "?id=" ).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const layMauChamCong = async (request: LayMauFileChamCongRequest) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.layMauChamCong, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const taiDuLieuChamCongThang = async (request: LayMauFileChamCongRequest) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.taiDuLieuChamCongThang, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const layChamCong = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.chamCong.layChamCongThang + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((e) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const luuTaiLieuChamCong = async (request: any) => {
    var rs: any;
    const formData = new FormData();
    formData.append("id", request?.id ?? "");

    // danh sách id tài liệu xóa
    request?.idsTaiLieuXoa?.forEach((id: number, index: number) => {
        formData.append(`idsTaiLieuXoa[${index}]`, String(id));
    });

    // danh sách file
    request?.files?.forEach((file: File) => {
        formData.append("files", file);
    });


    await intance.post(ApiPaths.chamCong.luuTaiLieuChamCong, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}
export const luuChamCong = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.luuChamCong, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err.message || 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const thuHoiChamCong = async (request: any) => {
    await intance.post(ApiPaths.chamCong.thuHoiChamCong + "?id=" + request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const trinhLDPhongChamCong = async (request: any) => {
    await intance.post(ApiPaths.chamCong.trinhLDPhongChamCong + "?id=" + request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const lDPhongDuyetChamCong = async (request: any) => {
    await intance.post(ApiPaths.chamCong.lDPhongDuyetChamCong, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
};

export const lDPhuTrachDuyetChamCong = async (request: any) => {
    await intance.post(ApiPaths.chamCong.lDPhuTrachDuyetChamCong, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
};
export const xoaChamCong = async (request: any) => {
    await intance.post(ApiPaths.chamCong.xoaChamCong + "?id=" + request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
};

export const importFileChamCong = async (request: ImportFileChamCongRequest) => {
    var rs: Array<ChamCongNhanVien> = new Array<ChamCongNhanVien>();
    await intance.post(ApiPaths.chamCong.importFileChamCong,
        request,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
            },
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};


export const layDanhSachChamNgoaiGio = async () => {
    var rs: any;
    await intance.get(ApiPaths.chamCongNgoaiGio.layDanhSachChamNgoaiGio).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const layDanhSachChamNgoaiGioChoDuyet = async () => {
    var rs: any;
    await intance.get(ApiPaths.chamCongNgoaiGio.layDanhSachChamNgoaiGioChoDuyet).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const layMauChamNgoaiGio = async (request: LayMauFileChamCongRequest) => {
    var rs: any;
    await intance.post(ApiPaths.chamCongNgoaiGio.layMauNgoaiGio, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const importFileNgoaiGio = async (request: ImportFileChamCongRequest) => {
    var rs: Array<CongNgoaiGioNhanVien> = new Array<CongNgoaiGioNhanVien>();
    await intance.post(ApiPaths.chamCongNgoaiGio.importFileNgoaiGio,
        request,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
            },
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const luuChamNgoaiGio = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCongNgoaiGio.luuChamNgoaiGio, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err.message || 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const layNgoaiGio = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.chamCongNgoaiGio.layChamNgoaiGio + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((e) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const thuHoiNgoaiGio = async (request: any) => {
    await intance.post(ApiPaths.chamCongNgoaiGio.thuHoiNgoaiGio + "?id=" + request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const trinhLDPhongNgoaiGio = async (request: any) => {
    await intance.post(ApiPaths.chamCongNgoaiGio.trinhLDPhongNgoaiGio + "?id=" + request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const lDPhongDuyetNgoaiGio = async (request: any) => {
    await intance.post(ApiPaths.chamCongNgoaiGio.lDPhongDuyetNgoaiGio, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
};

export const lDPhuTrachDuyetNgoaiGio = async (request: any) => {
    await intance.post(ApiPaths.chamCongNgoaiGio.lDPhuTrachDuyetNgoaiGio, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
};

export const xoaNgoaiGio = async (request: any) => {
    await intance.post(ApiPaths.chamCongNgoaiGio.xoaNgoaiGio + "?id=" + request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
};

export const taiDuLieuChamNgoaiGio = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCongNgoaiGio.taiDuLieuChamNgoaiGio, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const thongKeBangChamCongTheoDonVi = async (data: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.thongKeBangChamCongTheoDonVi,data).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
};

export const vanPhongTraLaiChamCongTongHop = async (data: any) => {
    var rs: any;
    await intance.post(ApiPaths.chamCong.vanPhongTraLaiChamCongTongHop, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}